import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  public REST_API_SERVER:string = `${environment.REST_API_URL}/api/web/${environment.version}`;

  constructor(private http:HttpClient) { }

  getTimezones():Observable<any>{
    return this.http.get(`${this.REST_API_SERVER}/users/gettimezones`);
  }
}
